export enum CookiesKeys {
  AdId = 'ad_id',
  DeleteAccount = 'DeleteAccount',
  Subscription = 'subscription',
  SubscriptionPurchase = 'subscriptionPurchase',
  BigOrderPurchase = 'bigOrderPurchase',
  WebViewToken = 'app_auth'
}
